import { type Themeable, useThemeable } from '../../themeable'
import type { AnimationProps } from '../../useKeyedAnimation'
import type { DefaultContent } from '../DefaultContent'
import { Body } from './Body'
import { Container } from './Container'
import { MarginalContent } from './MarginalContent'
import type { Options } from './Options'
import { Positioning } from './Positioning'

type Props = DefaultContent &
	AnimationProps & {
		themeableOptions: Themeable<Options>
	}

export const Card = ({ themeableOptions, body, header, footer, status, duration }: Props) => {
	const options = useThemeable(themeableOptions)
	return (
		<Positioning>
			<Container {...options} status={status} duration={duration}>
				{header && <MarginalContent>{header}</MarginalContent>}
				<Body>{body}</Body>
				{footer && <MarginalContent>{footer}</MarginalContent>}
			</Container>
		</Positioning>
	)
}
